import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useLocale } from "@react-aria/i18n";
import { useCalendarGrid } from "@react-aria/calendar";
import { getWeeksInMonth } from "@internationalized/date";
import "../ThemeProvider/ThemeProvider.mjs";
import "../ThemePortal/ThemePortal.mjs";
import "../Text/TextContext.mjs";
import "../ThemeProvider/ThemeContext.mjs";
import "../ThemeProvider/VanillaThemeContainer.mjs";
import "../private/DefaultMessagesContext.mjs";
import "../ThemeProvider/BreakpointContext.mjs";
import "../../css/atoms/sprinkles.css.mjs";
import { PublicBox } from "../Box/Box.mjs";
import "../Box/BackgroundContext.mjs";
import "../Divider/Divider.css.mjs";
import "../Heading/HeadingContext.mjs";
import "../Hidden/Hidden.css.mjs";
import "../../css/negativeMargin/negativeMargin.css.mjs";
import "../Accordion/AccordionContext.mjs";
import { Text } from "../Text/Text.mjs";
import "../Columns/ColumnsContext.mjs";
import "../Column/Column.css.mjs";
import "../../css/lineHeightContainer.css.mjs";
import "../../css/reset/reset.css.mjs";
import "../../hooks/useIcon/icon.css.mjs";
import "../../css/typography.css.mjs";
import "../private/touchable/virtualTouchable.css.mjs";
import "../private/hideFocusRings/hideFocusRings.css.mjs";
import "../Accordion/AccordionItem.css.mjs";
import "../Actions/ActionsContext.mjs";
import "../../css/textAlignedToIcon.css.mjs";
import "../Alert/Alert.css.mjs";
import "../Autosuggest/Autosuggest.mjs";
import "../Avatar/Avatar.css.mjs";
import "../Badge/Badge.mjs";
import "../Breadcrumb/Breadcrumb.css.mjs";
import "../Box/ColoredBox.mjs";
import "../Button/Button.mjs";
import "../ButtonIcon/ButtonIcon.mjs";
import "../ButtonLink/ButtonLink.mjs";
import "../private/Keyline/Keyline.css.mjs";
import "../Checkbox/Checkbox.mjs";
import "../Checkbox/CheckboxStandalone.mjs";
import "../ContentBlock/ContentBlock.css.mjs";
import "./DateField.mjs";
import "../private/Field/FloatingLabel.css.mjs";
import "../private/Field/Field.css.mjs";
import { weekDay } from "./DateField.css.mjs";
import { CalendarCell } from "./CalendarCell.mjs";
import "../private/Modal/Modal.mjs";
import "../private/Modal/ModalContent.mjs";
import "../private/Modal/ModalContext.mjs";
import "../TextLink/TextLink.mjs";
import "../TextLinkButton/TextLinkButton.css.mjs";
import "../private/AvoidWidowIcon/AvoidWidowIcon.css.mjs";
import "../Dropdown/Dropdown.mjs";
import "../private/MaxLines/MaxLines.css.mjs";
import "../HiddenVisually/HiddenVisually.css.mjs";
import "../Link/Link.mjs";
import "../private/defaultTextProps.mjs";
import "../List/List.css.mjs";
import "../Loader/Loader.css.mjs";
import "../Skeleton/Skeleton.css.mjs";
import "../MenuRenderer/MenuRenderer.mjs";
import "../MenuItem/MenuItem.mjs";
import "../MenuItemCheckbox/MenuItemCheckbox.mjs";
import "../MenuItemDivider/MenuItemDivider.mjs";
import "../MenuItem/MenuItemLink.mjs";
import "../OverflowMenu/OverflowMenu.css.mjs";
import "../MonthPicker/MonthPicker.mjs";
import "../Pagination/Pagination.css.mjs";
import "../PasswordField/PasswordField.mjs";
import "../Pincode/Pincode.mjs";
import "../PopoverRenderer/PopoverRenderer.mjs";
import "../Pressable/Pressable.mjs";
import "../RadioGroup/RadioGroup.mjs";
import "../RadioGroup/RadioItem.mjs";
import "../RadioGroup/RadioItemBlock.mjs";
import "../SelectableList/SelectableList.css.mjs";
import "../private/BulkActions/BulkActions.css.mjs";
import "../Spread/Spread.css.mjs";
import "../Stepper/Step.mjs";
import "../Stepper/Stepper.mjs";
import "../Tabs/Tab.mjs";
import "../Table/Table.mjs";
import "../Table/Table.css.mjs";
import "../Tabs/TabsProvider.mjs";
import "../Tabs/TabListContext.mjs";
import "../Tabs/Tabs.css.mjs";
import "../Tabs/TabPanelsContext.mjs";
import "../Tag/Tag.css.mjs";
import "../Textarea/Textarea.mjs";
import "../TextDropdown/TextDropdown.css.mjs";
import "../TextField/TextField.mjs";
import "../Tiles/Tiles.css.mjs";
import "../Toggle/Toggle.mjs";
import "../useToast/ToastContext.mjs";
import "../TooltipRenderer/TooltipRenderer.mjs";
import "../TimeField/DateSegment.css.mjs";
import "../private/FieldButtonIcon/FieldButtonIcon.mjs";
import "../MultiStepModal/MultiStepModal.mjs";
import "../SearchField/SearchField.mjs";
import "../RadioBar/RadioBarContext.mjs";
import "../RadioBar/RadioBar.css.mjs";
import "../../themes/vars.css.mjs";
import "../RadioBar/RadioBar.mjs";
const CalendarGrid = ({
  state,
  shortcuts,
  type
}) => {
  const { locale } = useLocale();
  const { gridProps, headerProps, weekDays } = useCalendarGrid({}, state);
  const weeksInMonth = getWeeksInMonth(state.visibleRange.start, locale);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("table", { ...gridProps, children: [
      /* @__PURE__ */ jsx("thead", { ...headerProps, children: /* @__PURE__ */ jsx("tr", { children: weekDays.map((day, index) => /* @__PURE__ */ jsx("th", { children: /* @__PURE__ */ jsx(PublicBox, { width: "medium", height: "medium", className: weekDay, children: /* @__PURE__ */ jsx(Text, { size: "small", children: day }) }) }, index)) }) }),
      /* @__PURE__ */ jsx("tbody", { children: [...new Array(weeksInMonth).keys()].map((weekIndex) => /* @__PURE__ */ jsx("tr", { children: state.getDatesInWeek(weekIndex).map(
        (date, i) => date ? /* @__PURE__ */ jsx(CalendarCell, { state, date, type }, i) : /* @__PURE__ */ jsx("td", {}, i)
      ) }, weekIndex)) })
    ] }),
    shortcuts && /* @__PURE__ */ jsx(PublicBox, { maxWidth: "large", background: "brandAccent", children: shortcuts })
  ] });
};
export {
  CalendarGrid
};
